import { render, staticRenderFns } from "./documentacionLegal.vue?vue&type=template&id=3296cb1b&scoped=true"
import script from "./documentacionLegal.vue?vue&type=script&lang=js"
export * from "./documentacionLegal.vue?vue&type=script&lang=js"
import style0 from "./documentacionLegal.vue?vue&type=style&index=0&id=3296cb1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3296cb1b",
  null
  
)

export default component.exports